module.exports = __webpack_public_path__ + "static/bot-laptop-01aed055a13997edf38d6dffddf07da8.svg";